module.exports = __webpack_public_path__ + "img/home_28.cac86d02.png";